import {
  addProgram,
  getTotalPoints,
  newGetTotalPoints,
  getAuthorizedClients,
  getProgrammes,
  getProgrammeByProgramId,
  updateProgramNameById,
  updateProgramById,
  toggleStatusProgramContest,
  getAllProgramByClient,
  editAllProgramOrContest,
  getProgrammesList,
} from '@/api/point-programs';

const adminPointPrograms = {
  namespaced: true,
  state: () => ({
    AuthorixedClients: [],
    ClientPrograms: [],
    ClientProgramsList: [],
    ProgramById: {},
    AllClientPrograms: [],
  }),
  getters: {
    getAuthorizedClients: (state) => {
      return state.AuthorixedClients;
    },
    getClientPrograms: (state) => {
      return state.ClientPrograms;
    },
    getProgramById: (state) => {
      return state.ProgramById;
    },
    getAllClientPrograms: (state) => {
      return state.AllClientPrograms;
    },
    getClientProgramsList: (state) => {
      return state.ClientProgramsList;
    },
  },
  actions: {
    insertProgram({ commit }, payload) {
      return new Promise((resolve, reject) => {
        addProgram(payload)
          .then((programId) => {
            resolve(programId);
          })
          .catch(() => {
            console.log('error in admin point program state');
          });
      });
    },

    fetchAuthorizedClients({ commit }) {
      return new Promise((resolve, reject) => {
        console.log('hello from clients fetch');
        getAuthorizedClients()
          .then((clients) => {
            console.log(clients);
            commit('SET_AUTHORIZED_CLIENTS', clients);
          })
          .catch(() => {
            console.log('error from fetchAuthorizedClients store');
          });
      });
    },

    fetchProgrammes({ commit }, payload) {
      console.log(payload, 'store');
      return new Promise((resolve, reject) => {
        getProgrammes(payload)
          .then((programs) => {
            commit('SET_CLIENT_PROGRAMS', programs);
          })
          .catch(() => {
            console.log('error from fetchProgrammes store.');
          });
      });
    },

    fetchProgramsList({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getProgrammesList(payload)
          .then((programs) => {
            commit('SET_CLIENT_PROGRAMS_LIST', programs);
          })
          .catch(() => {
            console.log('error from fetchProgrammes list store.');
          });
      });
    },

    getTotalPoints({ commit }, payload) {
      return getTotalPoints(payload);
    },

    newGetTotalPoints({ commit }, payload) {
      return newGetTotalPoints(payload);
    },

    getAuthorizedClients({ commit }) {
      return getAuthorizedClients();
    },

    fetchProgramDetailsById({ commit }, payload) {
      console.log(payload, 'from program store');
      return new Promise((resolve, reject) => {
        getProgrammeByProgramId(payload)
          .then((program) => {
            commit('SET_PROGRAM_BY_ID', program);
          })
          .catch(() => {
            console.log('error from fetch program details by id.');
          });
      });
    },

    updateProgramName({ commit }, payload) {
      console.log(payload, 'from api');
      return new Promise((resolve, reject) => {
        updateProgramNameById(payload)
          .then((resp) => {
            resolve(resp);
          })
          .catch(() => {
            console.log('error while store calling update name method');
          });
      });
    },

    updateProgram({ commit }, payload) {
      console.log(payload, 'from api admin');
      return new Promise((resolve, reject) => {
        updateProgramById(payload)
          .then((programId) => {
            resolve(programId);
          })
          .catch('error from store calling update program');
      });
    },

    activateDeactivateProgramContest({ commit }, payload) {
      console.log(payload, 'hello');
      return new Promise((resolve, reject) => {
        toggleStatusProgramContest(payload)
          .then((status) => {
            resolve(status);
          })
          .catch(() => {
            console.log('error from activate point store');
          });
      });
    },

    fetchAllProgramsByClient({ commit }, payload) {
      console.log(payload, 'from client');
      return new Promise((resolve, reject) => {
        getAllProgramByClient(payload)
          .then((allClientPrograms) => {
            commit('SET_ALL_CLINETS_PROGRAMS', allClientPrograms);
          })
          .catch(() => {
            console.log('error while all programs store');
          });
      });
    },

    updateAllProgramOrContest({ commit }, payload) {
      return new Promise((resolve, reject) => {
        editAllProgramOrContest(payload)
          .then((status) => {
            resolve(status);
          })
          .catch(() => {
            console.log('error from admin store update all');
          });
      });
    },
  },

  mutations: {
    SET_AUTHORIZED_CLIENTS: (state, clients) => {
      state.AuthorixedClients = clients ? clients : [];
    },
    SET_CLIENT_PROGRAMS: (state, programs) => {
      state.ClientPrograms = programs ? programs : [];
    },
    SET_PROGRAM_BY_ID: (state, program) => {
      state.ProgramById = program ? program : {};
    },
    SET_ALL_CLINETS_PROGRAMS: (state, allClientPrograms) => {
      state.AllClientPrograms = allClientPrograms.length > 0 ? allClientPrograms : [];
    },
    SET_CLIENT_PROGRAMS_LIST: (state, programs) => {
      state.ClientProgramsList = programs.length > 0 ? programs : [];
    },
  },
};

export default adminPointPrograms;
